/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

type EventListener = [
  HTMLElement | Window | Document | VisualViewport,
  string,
  EventListenerOrEventListenerObject,
  (boolean | AddEventListenerOptions)?,
];

export class EventManager {
  private readonly globalListeners: EventListener[] = [];
  private readonly contextListeners: EventListener[] = [];

  addListener = (
    element: HTMLElement | Window | Document | VisualViewport,
    event: string,
    handler: EventListenerOrEventListenerObject,
  ): EventListener => {
    element.addEventListener(event, handler);
    const listener: EventListener = [element, event, handler];
    this.globalListeners.push(listener);
    return listener;
  };

  addContextListener = (
    element: HTMLElement | Window | Document,
    event: string,
    handler: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ): EventListener => {
    element.addEventListener(event, handler, options);
    const listener: EventListener = [element, event, handler, options];
    this.contextListeners.push(listener);
    return listener;
  };

  removeAllListeners(): void {
    this.removeListeners(this.globalListeners);
    this.removeContextListeners();
  }

  removeContextListeners(): void {
    this.removeListeners(this.contextListeners);
  }

  private removeListeners(listeners: EventListener[]): void {
    listeners.forEach(([element, event, handler, options]) => {
      element.removeEventListener(event, handler, options);
    });
    listeners.length = 0;
  }
}
